import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TreeNode } from 'primeng/api';
import { TreeModule, TreeNodeSelectEvent } from 'primeng/tree';
import { DOCS_PREFIX } from '../docs.model';

@Component({
  selector: 'app-docs-tree',
  standalone: true,
  imports: [TreeModule],
  templateUrl: './docs-tree.component.html',
  styleUrl: './docs-tree.component.scss'
})
export class DocsTreeComponent implements OnInit {
  router = inject(Router)
  activeRoute = inject(ActivatedRoute)

  activeSelection: TreeNode | undefined

  documentTree: TreeNode[] = [
    {
      label: 'Getting Started',
      icon: 'pi fi fi-rr-running',
      key: "user",
      selectable: false,
      expanded: true,
      children: [
        {
          label: "Quick Start Guide",
          data: "quick-start",
          icon: 'pi fi fi-rr-time-fast'
        },
        {
          label: "Plugin Module Settings",
          data: "rorender-settings",
          icon: 'pi fi fi-rr-api'
        },
        {
          label: "Tips and Tricks",
          data: "tips-and-tricks",
          icon: 'pi fi fi-rr-lightbulb-on'
        },
      ]
    },
  ]

  flattenTree(tree: TreeNode[]): TreeNode[] {
    const flatArray: TreeNode[] = [];

    const traverse = (nodes: TreeNode[]) => {
      for (const node of nodes) {
        flatArray.push(node); // Add the current node to the flat array
        if (node.children) {
          traverse(node.children); // Recursively process children
        }
      }
    };

    traverse(tree);
    return flatArray;
  }

  onNodeSelect(event: TreeNodeSelectEvent) {
    const dir = event.node.data as string
    this.router.navigate(['docs', ...dir.split('/')])
  }

  ngOnInit(): void {
    const fullUrl = this.router.url
    const urlPrefix = DOCS_PREFIX

    let docPath = fullUrl.slice(urlPrefix.length);
    if (!docPath) {
      docPath = "/index"
    }
    docPath = docPath.replace("/", "")
    const flatTree = this.flattenTree(this.documentTree)
    this.activeSelection = flatTree.flat().find(x => x.data === docPath)
  }
}
